import { getApiUrl, AXIOS_ADMIN_AUTHED, getAxiosInstanceByLoginMode } from './shared';

const get = () => {
  return getAxiosInstanceByLoginMode().get(
    `${getApiUrl()}/branches?includeInactive=true&sort=branchDesc,asc&size=1000`
  );
};

const getInactiveOnly = () => {
  return AXIOS_ADMIN_AUTHED.get(
    `${getApiUrl()}/branches?onlyIncludeInactive=true&includeInactive=true`
  );
};

export { get, getInactiveOnly };
